
import Vue from 'vue'
import { RLoader } from '@/components'

/**
 * copy of FileBrowser, trimmed down to be more general and to include necessary styling
 */
export default Vue.extend({
  name: 'ItemListing',
  components: {
    RLoader,
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    hasAnyBodyRows(): boolean {
      return !!this.$slots.body?.length
    },
  },
})
